import { useMemo } from "react";

import { trafficCopMock } from "@/api/catalogs/mockData/trafficCop";
import { useGetUser } from "@/users/v3";
import useGetUserClassrooms from "@/classrooms/hooks/useGetUserClassrooms";
import type { QueryKey } from "@tanstack/react-query";

interface UseTrafficCopProps {
  enabled?: boolean;
  queryKey?: QueryKey;
  prompt?: string;
  chips?: [];
  isExperimentModeRandomSelection?: boolean;
}

export const useTrafficCopQuery = ({
  enabled = false,
  queryKey = ["default"],
  prompt = "",
  chips = [],
  isExperimentModeRandomSelection = true,
}: UseTrafficCopProps): any => {
  const { data: userData } = useGetUser();
  const { data: userClassrooms } = useGetUserClassrooms({
    userUniqueId: userData?.unique_id,
    enabled: true,
  });

  const userClassroomGradeLevels = useMemo(() => {
    if (userClassrooms) {
      return [
        ...new Set(
          userClassrooms.results.map((classroom) => {
            return classroom.grade;
          }),
        ),
      ];
    } else {
      return [];
    }
  }, [userClassrooms]);

  const userClassroomSubjects = useMemo(() => {
    if (userClassrooms) {
      return [
        ...new Set(
          userClassrooms.results.map((classroom) => {
            return classroom.subjects;
          }),
        ),
      ].flat();
    } else {
      return [];
    }
  }, [userClassrooms]);

  // TODO: This is a mock payload, replace values once
  // we wire up the real endpoint.
  const payload = {
    prompt,
    data: {
      chips,
      user_attributes: {
        grade_levels: userClassroomGradeLevels,
        subjects: userClassroomSubjects,
        region_codes: [],
      },
      experiment_mode: isExperimentModeRandomSelection
        ? "random_selection"
        : null,
    },
  };

  return {
    data: trafficCopMock,
    isLoading: false,
    isError: false,
    error: null,
    payload,
    queryKey,
    enabled,
    status: "success",
    refetch: () => ({ data: trafficCopMock }) as any,
  };
};
